import React from "react";
import { Link, useParams } from "react-router-dom";

import CandidateProfileEditContent from "./CandidateProfileEditContent";
import "./CandidateProfileEdit.css";

/**
 * Standalone admin page for editing candidate profile.
 * Route: /candidate-profile-edit/:userId
 */
const CandidateProfileEditPage = () => {
  const { userId } = useParams();

  return (
    <div className="cpe-page">
      <div style={{ maxWidth: 1200, margin: "0 auto 12px" }}>
        <Link to="/approve-individual" className="back-link">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="m15 18-6-6 6-6" />
          </svg>
          Back to Individual Candidates
        </Link>
      </div>

      <div className="cpe-page-layout">
        <CandidateProfileEditContent userId={userId} variant="page" />
      </div>
    </div>
  );
};

export default CandidateProfileEditPage;
